import { t } from "../../i18n";
/** Oran çubuğu; `cad` = CadTable boyutu (README §2.4: 44×5 px, kanal #E9ECF2, ≤1 yeşil / >1 kırmızı) */
export function RatioBar({ ratio, ok, label, cad }: { ratio: number; ok: boolean; label: string; cad?: boolean }): JSX.Element {
  const r = Number.isFinite(ratio) ? ratio : 2;
  const pct = Math.min(100, (r / 1.25) * 100);
  const color = !ok || r > 1 ? "bg-bad" : r > 0.85 ? "bg-warn" : "bg-ok";
  if (cad) {
    return (
      <span role="meter" aria-label={label} aria-valuemin={0} aria-valuemax={1.25} aria-valuenow={Math.min(r, 1.25)} className="relative inline-block w-11 h-[5px] bg-[#E9ECF2] align-middle shrink-0">
        <span className={`block h-full ${!ok || r > 1 ? "bg-[#B42318]" : "bg-[#1D7A46]"}`} style={{ width: `${pct}%` }} />
        <span className="absolute top-0 h-full w-px bg-[#8A9099]" style={{ left: "80%" }} title={t("sınır (1,0)")} />
      </span>
    );
  }
  return (
    <div role="meter" aria-label={label} aria-valuemin={0} aria-valuemax={1.25} aria-valuenow={Math.min(r, 1.25)} className="relative h-2 w-full rounded bg-ink-light overflow-hidden">
      <div className={`h-full ${color}`} style={{ width: `${pct}%` }} />
      <div className="absolute top-0 h-full w-px bg-stone" style={{ left: "80%" }} title={t("sınır (1,0)")} />
    </div>
  );
}
